import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
  Box,
} from "@mui/material";
import GoodsTransfer from "./GoodsTransfer";
import CustomerSiteTransfer from "./CustomerSiteTransfer";


const TransferPage = () => {
  const [transferType, setTransferType] = useState("customer");

  return (
    <Box width="100%" sx={{ mt: 4 }}>
      <Paper sx={{ p: 1, borderRadius: 3 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "#1976d2" }}
        >
          Goods Transfer Management
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* RADIO SECTION */}
        <FormControl>
          <RadioGroup
            row
            value={transferType}
            onChange={(e) => setTransferType(e.target.value)}
          >
            <FormControlLabel
              value="customer"
              control={<Radio />}
              label="Site Transfer"
            />
            <FormControlLabel
              value="goods"
              control={<Radio />}
              label="Location Transfer"
            />
          </RadioGroup>
        </FormControl>

        <Divider sx={{ my: 3 }} />

        {/* CONDITIONAL RENDERING */}
        <Box>
          {transferType === "goods" && <GoodsTransfer />}
          {transferType === "customer" && <CustomerSiteTransfer />}
        </Box>
      </Paper>
    </Box>
  );
};

export default TransferPage;